module.exports = __webpack_public_path__ + "808f92207406130520fa83777ca53ded.jpg";